<template>
  <el-drawer
    v-if="visible"
    visible
    show-close
    :size="850"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    direction="rtl"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        :disabled="disabled"
        :riskCheckCode="riskCheckCode"
        @close="close"
        @reload="$emit('reload')"
      />
    </div>
    <div class="d-flex justify-content-end" style="padding: 20px;">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        v-if="!disabled"
        type="primary"
        size="small"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    riskCheckCode: { type: String, default: '' },
  },
  computed: {
    titleMap() {
      return {
        edit: this.$l('dialog_title_edit') || '核查记录编辑',
        detail: this.$l('dialog_title_detail') || '核查记录详情',
      }
    },
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 0;
}
</style>
